<template>
  <Admin style="background: white">
    <v-main v-if="!isProductListLoading" class="wrapper">
      <v-container v-if="!selectedCompanyProductList.isTopserv" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"
          ><b><u>026637895</u></b></a
        >
      </v-container>
      <v-container v-else fluid>
        <v-card>
          <div class="table-container">
            <div class="pt-8 table-toolbar">
              <v-row class="px-3 pa-0 tw-gap-4">
                <v-col cols="4" class="pa-0">
<!--
                   <v-btn
                    color="primary"
                    class="py-6"
                    @click="openConfirmDialog"
                    :disabled="
                      !areItemsSelected || !areDocsEligibleForConfirmation
                    "
                  >
                    <v-icon left>mdi-check</v-icon>
                    ยืนยันเอกสาร
                  </v-btn>
-->
                  <v-btn color="primary" class="py-6" @click="exportAsExcel">
                    Export to Excel
                  </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col class="tw-flex pa-0" cols="2">
                  <!-- dropdown of radio button column for searching keyword  -->
                  <div class="tw-w-2/3"></div>
                  <v-select
                    v-model="selectedSearchColumn"
                    :items="searchColumns"
                    label="ค้นหาจาก"
                    outlined
                  ></v-select>
                </v-col>
                <v-col
                  v-if="selectedSearchColumn === 'taxID'"
                  class="pa-0"
                  cols="2"
                >
                  <v-text-field
                    class="ma-0 pa-0"
                    label="ค้นหาเอกสาร"
                    v-model="searchKeywords"
                    append-icon="mdi-magnify"
                    :placeholder="`${selectedSearchColumnLabel}`"
                    @input="debounceInput"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col
                  v-if="selectedSearchColumn === 'documentDate'"
                  class="pa-0"
                  cols="4"
                >
                  <date-range-search
                    :on-reset="resetDateSearch"
                    :on-search="searchTopservInvoicesByDateRange"
                  />
                </v-col>
              </v-row>
            </div>
            <table class="custom-table">
              <thead>
                <tr>
                  <th>
                    <v-checkbox
                      class="ma-0 pa-0 tw-transform tw-translate-y-3"
                      v-model="selectAll"
                      @change="toggleAll"
                      color="primary"
                    ></v-checkbox>
                  </th>
                  <th>DocumentDate</th>
                  <th>TaxID</th>
                  <th>JobOrderCode</th>
                  <th>EstimateCode</th>
                  <th>CustomerCode</th>
                  <th>CustomerName</th>
                  <th>BranchName</th>
                  <!-- <th>Address</th> -->
                  <th class="tw-text-right">BeforeVAT</th>
                  <th class="tw-text-right">SpecialDiscount</th>
                  <th class="tw-text-right">VAT</th>
                  <th class="tw-text-right">AfterVAT</th>
                  <th>PaymentType</th>
                  <!-- <th>VBPBranchCode</th>
                <th>Department</th>
                <th>CusType</th>
                <th>InvoiceType</th>
                <th>SLD_API</th>
                <th>DocStatus</th> -->
                  <!-- <th></th> -->
                </tr>
              </thead>
              <tbody v-if="displayedItems?.length !== 0">
                <tr
                  v-for="(item, index) in displayedItems"
                  :key="index"
                  @click="showDocDetailDialog(item)"
                >
                  <td @click.stop>
                    <v-checkbox
                      class="ma-0 pa-0 tw-transform tw-translate-y-3"
                      v-model="selectedItems"
                      :value="getCheckboxValue(item)"
                    ></v-checkbox>
                  </td>
                  <td>{{ getDateWithFormat(item.documentDate) }}</td>
                  <td @click.stop>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" @click="copyToClipboard(item.taxID)" class="hover:tw-opacity-70"  style="user-select: none;">{{
                          item.taxID
                        }}</span>
                      </template>
                      <span>
                        <v-icon color="white">mdi-content-copy</v-icon>
                        คลิกเพื่อคัดลอก</span
                      >
                    </v-tooltip>
                  </td>
                  <td>{{ item.jobOrderCode }}</td>
                  <td>{{ item.estimateCode }}</td>
                  <td>{{ item.customerCode }}</td>
                  <td>{{ item.customerName }}</td>
                  <td>{{ item.branchNameTH }}</td>
                  <!-- <td>{{ item.address }}</td> -->
                  <td class="tw-text-right">{{ formatNum(item.beforeVAT) }}</td>
                  <td class="tw-text-right">{{ formatNum(item.specialDiscount) }}</td>
                  <td class="tw-text-right">{{ formatNum(item.vat) }}</td>
                  <td class="tw-text-right">{{ formatNum(item.afterVAT) }}</td>
                  <td class="tw-text-center">
                    {{ getPaymentInThai(item.paymentType) }}
                  </td>
                  <!-- <td>{{ item.VBPBranchCode }}</td>
                <td>{{ item.Department }}</td>
                <td>{{ item.CusType }}</td>
                <td>{{ item.InvoiceType }}</td>
                <td>{{ item.SLD_API }}</td>
                <td>{{ item.DocStatus }}</td> -->
                  <!-- <td>
                  <button
                    class="tw-text-lg custom-button"
                    @click.stop="deleteDocument(item)"
                  >
                    <v-icon color="error">mdi-delete</v-icon>
                  </button>
                </td> -->
                </tr>
              </tbody>
              <tbody v-else>
                <tr class="tw-h-136">
                  <td colspan="14" class="tw-text-center tw-opacity-60">
                    <v-icon size="20">mdi-alert-circle-outline</v-icon>
                    ไม่มีข้อมูล
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Pagination Controls -->
        </v-card>
        <v-row justify="start" class="tw-my-4">
          <v-col
          >
            <select class="items-per-page-selector" v-model="itemsPerPage">
              <option v-for="option in itemsPerPageOptions" :key="option" :value="option" :selected="option === itemsPerPage">
                {{ option }}
              </option>
            </select>
          </v-col>
          <v-col>
            <v-pagination
              v-model="currentPage"
              :length="numPages"
              :total-visible="6"
              @input="paginate"
            ></v-pagination>
          </v-col>
          <v-col>
            <p class="total-item">จำนวนเอกสารทั้งหมด: {{ totalItems }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-main v-else>
      <div class="tw-flex tw-justify-center tw-mt-20">
        <v-progress-circular
          :size="30"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-main>

    <div v-if="isOpenCustomDialogue" class="custom-dialogue">
      <div if="selectedDoc" class="custom-dialogue-content-wrapper">
        <!-- header title  -->
        <div class="dialog-header-wrapper">
          <div class="tw-flex tw-justify-center">
            <span class="tw-font-bold tw-text-xl">รายละเอียดเอกสาร</span>
          </div>
        </div>
        <!-- content  -->
        <div class="dialog-content-wrapper">
          <div class="dialog-content">
            <div
              class="tw--translate-y-4 tw-transform tw-pt-10 tw-h-full tw-overflow-y-scroll"
            >
              <v-row class="mx-2">
                <v-col cols="4" xs="12" class="py-0">
                  <v-text-field
                    class="ma-0 pa-0"
                    label="TaxID"
                    readonly
                    :disabled="editMode"
                    :value="selectedDoc.taxID"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" xs="12" class="py-0">
                  <v-text-field
                    required
                    class="ma-0 pa-0"
                    :readonly="!editMode"
                    maxlength="5"
                    label="JobOrderCode"
                    v-model="selectedDoc.jobOrderCode"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" xs="12" class="py-0">
                  <v-text-field
                    required
                    class="ma-0 pa-0"
                    :readonly="!editMode"
                    maxlength="5"
                    label="EstimateCode"
                    v-model="selectedDoc.estimateCode"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- --------------------------- -->
              <v-row class="mx-2">
                <v-col cols="4" xs="12" class="py-0">
                  <v-text-field
                    class="ma-0 pa-0"
                    label="CustomerCode"
                    readonly
                    :disabled="editMode"
                    :value="selectedDoc.customerCode"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" xs="12" class="py-0">
                  <v-text-field
                    required
                    class="ma-0 pa-0"
                    :readonly="!editMode"
                    maxlength="5"
                    label="CustomerName"
                    v-model="selectedDoc.customerName"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4" xs="12" class="py-0">
                  <v-text-field
                    required
                    class="ma-0 pa-0"
                    :readonly="!editMode"
                    maxlength="5"
                    label="DocumentDate"
                    :value="getDateWithFormat(selectedDoc.documentDate)"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- --------------------------- -->
              <v-row class="mx-2">
                <v-col cols="12" xs="12" class="py-0">
                  <v-textarea
                    class="ma-0 pa-0"
                    label="Address"
                    v-model="selectedDoc.address"
                    outlined
                    :readonly="!editMode"
                    rows="2"
                  ></v-textarea>
                </v-col>
              </v-row>
              <!-- --------------------------- -->

              <div class="table-container-detail">
                <table class="mx-5 customer-table-detail">
                  <thead>
                    <th>ลำดับ</th>
                    <th>หมายเลข</th>
                    <th>ชื่อ</th>
                    <th>จำนวนหน่วย</th>
                    <th>ราคาต่อหน่วย</th>
                    <th class="tw-text-right tw-whitespace-nowrap">
                      ราคาสุทธิก่อนลด
                    </th>
                    <th class="tw-text-right tw-whitespace-nowrap">ส่วนลด%</th>
                    <th class="tw-text-right tw-whitespace-nowrap">
                      ส่วนลดมูลค่า
                    </th>
                    <th class="tw-text-right tw-whitespace-nowrap">
                      ราคาสุทธิหลังลด
                    </th>
                    <th class="tw-text-center">ประเภทบริการ</th>
                    <th class="tw-text-center">ประเภทงาน</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(doclineItem, index) in selectedDoc?.detailList"
                      :key="index"
                    >
                      <td align="center">{{ doclineItem?.item }}</td>
                      <td>
                        {{ doclineItem?.partNumber }}
                      </td>
                      <td>
                        {{ doclineItem?.partName }}
                      </td>
                      <td class="tw-text-right">
                        {{ formatNum(doclineItem.quantity) }}
                      </td>
                      <td class="tw-text-right">
                        {{ formatNum(doclineItem.unitPrice) }}
                      </td>
                      <td class="tw-text-right">
                        {{ formatNum(doclineItem.netAmount) }}
                      </td>
                      <td class="tw-text-right">
                        {{ formatNum(doclineItem.discount) }}
                      </td>
                      <td class="tw-text-right">
                        {{ formatNum(doclineItem.discountValue) }}
                      </td>
                      <td class="tw-text-right">
                        {{ formatNum(doclineItem.totalAmount) }}
                      </td>
                      <td class="tw-text-center">
                        {{ doclineItem?.serviceType }}
                      </td>
                      <td class="tw-text-center">
                        {{ doclineItem?.jobType }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5"></td>
                      <td class="tw-text-right">
                        {{ sumNetAmountDetailList() }}
                      </td>
                      <td colspan="2"></td>
                      <td class="tw-text-right">
                        {{ sumTotalAmountDetailList() }}
                      </td>
                      <td colspan="2"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- ------------------- -->
              <!-- --------------------------- -->
              <v-row class="mx-2">
                <v-col cols="3" xs="12" class="py-0">
                  <v-text-field
                    class="ma-0 pa-0"
                    label="BeforeVAT"
                    readonly
                    :disabled="editMode"
                    :value="formatNum(selectedDoc.beforeVAT)"
                    outlined
                    reverse
                  ></v-text-field>
                </v-col>
                <v-col cols="3" xs="12" class="py-0">
                  <v-text-field
                    required
                    class="ma-0 pa-0"
                    :readonly="!editMode"
                    maxlength="5"
                    label="Discount"
                    :value="formatNum(selectedDoc.specialDiscount)"
                    outlined
                    reverse
                  ></v-text-field>
                </v-col>
                <v-col cols="3" xs="12" class="py-0">
                  <v-text-field
                    required
                    class="ma-0 pa-0"
                    :readonly="!editMode"
                    maxlength="5"
                    label="VAT"
                    :value="formatNum(selectedDoc.vat)"
                    outlined
                    reverse
                  ></v-text-field>
                </v-col>

                <v-col cols="3" xs="12" class="py-0">
                  <v-text-field
                    required
                    class="ma-0 pa-0"
                    :readonly="!editMode"
                    maxlength="5"
                    label="AfterVAT"
                    :value="formatNum(selectedDoc.afterVAT)"
                    outlined
                    reverse
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>

        <div class="dialog-footer-wrapper tw-flex tw-gap-2">
          <v-spacer />
          <v-btn
            color="primary"
            v-if="!editMode"
            :disabled="isUpdating"
            class="tw-text-lg"
            @click="isOpenCustomDialogue = false"
            >ปิด
          </v-btn>
        </div>
      </div>
    </div>
    <v-snackbar timeout="2000" v-model="snackbarCopy" color="success" top>
      <!-- copy alt icon  -->
      <v-icon left>mdi-check</v-icon>
      คัดลอกเรียบร้อย
    </v-snackbar>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import _isEqual from "lodash/isEqual";
import { mapState } from "vuex";
import moment from "moment";
import DateRangeSearch from "@/components/admin/documents/date-range-search.vue";
import * as XLSX from "xlsx";
const _ = require("lodash");

export default {
  data() {
    return {
      isFetchingData: true,
      topservInvoices: [],
      displayedItems: [], // Items to display on the current page
      currentPage: 1, // Current page
      itemsPerPage: 10, // Items per page
      totalItems: 0, // Total number of items
      selectedItems: [], // Selected POIDs
      selectAll: false, // Select all flag
      dialogConfirmDocument: false,
      dialogConfirmDocumentOne: false,
      snackbarCopy: false,
      isOpenCustomDialogue: false,
      editMode: false, // Flag to track edit mode
      isUpdating: false,
      searchKeywords: "",
      selectedSearchColumn: "taxID",
      searchColumns: [
        { text: "Tax ID", value: "taxID" },
        { text: "Document Date", value: "documentDate" },
      ],
      itemsPerPageOptions: [5, 10, 20, 30, 40, 50],
    };
  },
  name: "documentTOPSERV",
  components: {
    DateRangeSearch,
    Admin,
  },
  mounted() {
    this.fetchTopservInvoices();
  },
  methods: {
    sumTotalAmountDetailList() {
      let result =
        this.selectedDoc?.detailList?.reduce((sum, item) => {
          const totalAmount = parseFloat(item?.totalAmount) || 0;
          return sum + totalAmount;
        }, 0) || 0;

      return this.formatNum(result);
    },
    sumNetAmountDetailList() {
      let result =
        this.selectedDoc?.detailList?.reduce((sum, item) => {
          const netAmount = parseFloat(item?.netAmount) || 0;
          return sum + netAmount;
        }, 0) || 0;

      return this.formatNum(result);
    },
    getPaymentInThai(paymentEN) {
      let paymentTH;
      switch (paymentEN) {
        case "Cash":
          paymentTH = "เงินสด";
          break;
        default:
          paymentTH = paymentEN;
          break;
      }

      return paymentTH || "";
    },
    showDocDetailDialog(doc) {
      // this.dialogDocDetail = true;
      this.selectedDoc = {
        ...doc,
      };
      this.isOpenCustomDialogue = true;
    },
    formatDate(timestamp) {
      if (!timestamp) return "";
      // Create a new Date object using the seconds from the timestamp
      const date = new Date(timestamp.seconds * 1000);

      // Extract the day, month, and year
      const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if needed
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed, so add 1
      const year = date.getFullYear();

      // Format the date as "DD/MM/YYYY"
      const formattedDate = `${day}/${month}/${year}`;

      return formattedDate;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.snackbarCopy = true;
    },
    formatNum(num) {
      if (!num) return "0";

      // Convert to a string to avoid automatic rounding
      let numStr = num.toString();

      // Find the position of the decimal point
      let decimalIndex = numStr.indexOf(".");

      // If there's a decimal point, truncate to two places
      if (decimalIndex !== -1) {
        numStr = numStr.substring(0, decimalIndex + 3);
      }

      // Convert back to a number for locale formatting
      let truncatedNum = Number(numStr);

      return truncatedNum.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getCheckboxValue(item) {
      return `${item.taxID}`;
    },
    toggleAll() {
      if (this.selectAll) {
        this.selectedItems = this.displayedItems.map((item) => item.taxID);
      } else {
        this.selectedItems = [];
      }
    },
    openConfirmDialog() {
      this.dialogConfirmDocument = true;
    },
    openConfirmOneDialog() {
      this.dialogConfirmDocumentOne = true;
    },
    async fetchTopservInvoices(_keyword, _keywordFromDate, _keywordToDate) {
      console.log(
        "fetchTopservInvoices",
        _keyword,
        " // ",
        _keywordFromDate,
        " // ",
        _keywordToDate
      );

      const companyID = this.$route.params.companyId;
      const _searchColumn = this.selectedSearchColumn || "taxID"; // Default search column

      let topservInvoicesRef = fc.db.collection(
        `Companies/${companyID}/TopservInvoices`
      );
      const endsWith = this.$route.params.endsWith;
      if (endsWith && endsWith !== "") {
        topservInvoicesRef = topservInvoicesRef.where("branchNameEN", "==", endsWith);
      }

      if (_keyword && _searchColumn === "taxID") {
        const _endKey = `${_keyword}\uf8ff`;
        topservInvoicesRef = topservInvoicesRef
          .where(_searchColumn, ">=", _keyword)
          .where(_searchColumn, "<=", _endKey);

        console.log(
          `%cSearch keyword: %c${_keyword}  %cSearch column: %c${_searchColumn}`,
          "color: #fff; font-weight: bold;",
          "color: #ff000f; font-weight: bold; background-color: #FFD700;",
          "color: #fff; font-weight: bold;",
          "color: #ff000f; font-weight: bold; background-color: #FFD700;"
        );
      }

      try {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
        this.unsubscribe = topservInvoicesRef
          .orderBy(_searchColumn)
          .onSnapshot((snapshot) => {
            this.topservInvoices = snapshot.docs.map((doc) => doc.data());
            this.totalItems = this.topservInvoices.length;
            this.paginate(); // Initial pagination
          });
      } catch (error) {
        console.error("Error fetching topservInvoices:", error);
      }
    },
    paginate() {
      console.log("page start");
      console.log("page current ", this.currentPage);
      console.log("perpage", this.itemsPerPage);
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      console.log("start", startIndex);
      console.log("end", endIndex);
      this.displayedItems = this.topservInvoices.slice(startIndex, endIndex);

      // Clear selection
      this.selectedItems = []; // Assuming you have a property named selectedItems

      // console.log("display", this.displayedItems);
    },
    resetSearchConfig() {
      this.searchKeywords = "";
      this.selectedSearchColumn = "taxID";
    },
    debounceInput: _.debounce(function (keyword) {
      this.fetchTopservInvoices(keyword);
    }, 1000),
    searchTopservInvoicesByDateRange(fromDate, toDate) {
      const companyID = this.$route.params.companyId;
      let topservInvoicesRef = fc.db.collection(
        `Companies/${companyID}/TopservInvoices`
      );
      try {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
        this.unsubscribe = topservInvoicesRef
          .orderBy("documentDate")
          .where("documentDate", ">=", fromDate)
          .where("documentDate", "<=", toDate)
          .onSnapshot((snapshot) => {
            this.topservInvoices = snapshot.docs.map((doc) => doc.data());
            this.totalItems = this.topservInvoices.length;
            this.paginate();
          });
      } catch (error) {
        console.error("Error fetching topservInvoices:", error);
      }
    },
    resetDateSearch() {
      this.fetchAllTopservInvoices();
    },
    async fetchAllTopservInvoices() {
      const companyID = this.$route.params.companyId;
      const topservInvoicesRef = fc.db.collection(
        `Companies/${companyID}/TopservInvoices`
      );
      try {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
        this.unsubscribe = topservInvoicesRef
          .orderBy("documentDate")
          .onSnapshot((snapshot) => {
            this.topservInvoices = snapshot.docs.map((doc) => doc.data());
            this.totalItems = this.topservInvoices.length;
            this.paginate();
          });
      } catch (error) {
        console.error("Error fetching topservInvoices:", error);
      }
    },
    getDateWithFormat(timestamp) {
      // Convert Firebase timestamp to milliseconds
      var milliseconds =
        timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000 + 100;

      // Create a JavaScript Date object from milliseconds
      var date = new Date(milliseconds);

      // Use moment.js to format the date
      var parsedDate = moment(date);

      // Format the date as per the desired output format
      var formattedDate = parsedDate.format("DD MMM", "th");

      // Convert the month to Thai abbreviation
      formattedDate = formattedDate.replace("Jan", "ม.ค.");
      formattedDate = formattedDate.replace("Feb", "ก.พ.");
      formattedDate = formattedDate.replace("Mar", "มี.ค.");
      formattedDate = formattedDate.replace("Apr", "เม.ย.");
      formattedDate = formattedDate.replace("May", "พ.ค.");
      formattedDate = formattedDate.replace("Jun", "มิ.ย.");
      formattedDate = formattedDate.replace("Jul", "ก.ค.");
      formattedDate = formattedDate.replace("Aug", "ส.ค.");
      formattedDate = formattedDate.replace("Sep", "ก.ย.");
      formattedDate = formattedDate.replace("Oct", "ต.ค.");
      formattedDate = formattedDate.replace("Nov", "พ.ย.");
      formattedDate = formattedDate.replace("Dec", "ธ.ค.");

      // Get the year in Thai Buddhist calendar
      var thaiYear = parseInt(parsedDate.format("YYYY")) + 543; // Add 543 to convert to Thai Buddhist calendar

      // Append the Thai Buddhist year to the formatted date
      formattedDate += " " + thaiYear.toString().substring(2, 4);

      return formattedDate;
    },
    exportAsExcel() {
      this.generateTopservExcelFile(this.topservInvoices);
    },
    async generateTopservExcelFile(data) {
      try {
        if (!data || data.length === 0) {
          console.log("No data available to generate Excel file.");
          return;
        }
        // Prepare data for TAXID sheet
        const topservHeader = data.map((item) => {
          const milliseconds =
            item.documentDate.seconds * 1000 + item.documentDate.nanoseconds / 1000000 + 100;
          const documentDate = new Date(milliseconds);
          return {
                    TaxID: item.taxID,
                    BranchNameEN: item.branchNameEN,
                    BranchNameTH: item.branchNameTH,
                    BranchCode: item.branchCode,
                    JobOrderCode: item.jobOrderCode,
                    EstimateCode: item.estimateCode,
                    InvoiceType: item.invoiceType,
                    Status: item.status,
                    DocumentDate: documentDate,
                    VBPBranchCode: item.vbpBranchCode,
                    Address: item.address,
                    CusType: item.cusType,
                    CustomerCode: item.customerCode,
                    CustomerName: item.customerName,
                    Department: item.department,
                    BeforeVAT: item.beforeVAT,
                    Vat: item.vat,
                    AfterVAT: item.afterVAT,
                    SpecialDiscount: item.specialDiscount,
                    PaymentType: item.paymentType,
          };
      });

        topservHeader.forEach((tax) => {
          console.log(tax.TaxID, ":", tax.BranchNameEN);
        });
        console.log("===========================================");
        // Prepare data for DetailList sheet
        const itemData = [];
        try {
          data.forEach((item) => {
            if (item.detailList && Array.isArray(item.detailList)) {
              item.detailList.forEach((detail) => {
                itemData.push({
                  TaxID: item.taxID,
                  OrderNumber: detail.orderNumber,
                  DocPartNo: detail.docPartNo,
                  PartName: detail.partName,
                  PartNumber: detail.partNumber,
                  Discount: detail.discount,
                  DiscountValue: detail.discountValue,
                  Item: detail.item,
                  UnitPrice: detail.unitPrice,
                  Quantity: detail.quantity,
                  NetAmount: detail.netAmount,
                  TotalAmount: detail.totalAmount,
                  JobType: detail.jobType,
                  ServiceType: detail.serviceType,
                  WHSCode: detail.whsCode,
                });
              });
            }
          });
        } catch (error) {
          console.log("Can't show DataList");
        }

        itemData.forEach((itemd) => {
          console.log(itemd.TaxID); //, " : ", itemd.PartNumber, " : ", itemd.TotalAmount
        });

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert TAXID data to a worksheet
        const taxidWorksheet = XLSX.utils.json_to_sheet(topservHeader);
        XLSX.utils.book_append_sheet(workbook, taxidWorksheet, "Header");

        // Convert Item data to a worksheet
        const itemWorksheet = XLSX.utils.json_to_sheet(itemData);
        XLSX.utils.book_append_sheet(workbook, itemWorksheet, "DetailList");

        // Get current date in YYYYMMDD format
        const currentDate = new Date()
          .toISOString()
          .split("T")[0]
          .replace(/-/g, "");

        // Write the workbook to a file
        const filename = `topservDocument_${currentDate}.xlsx`;
        XLSX.writeFile(workbook, filename);
        } catch (error) {
        console.log("Error generating Excel file:", error);
      }
    },
  },
  computed: {
    ...mapState({
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
    }),
    numPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    areItemsSelected() {
      return this.selectedItems.length > 0;
    },
    isDocUnchanged() {
      return _isEqual(this.selectedDoc, this.selectedDocCopy);
    },
    selectedSearchColumnLabel() {
      return this.searchColumns.find(
        (column) => column.value === this.selectedSearchColumn
      ).text;
    },
    fromDateDisp() {
      return this.fromDateVal;
      // format/do something with date
    },
    toDateDisp() {
      return this.toDateVal;
      // format/do something with date
    },
    minToDate() {
      // Calculate the minimum date (fromDateDisp + 1 day)
      const minDate = new Date(this.fromDateDisp);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().substr(0, 10); // Format as "YYYY-MM-DD"
    },
  },
  watch: {
    currentPage() {
      this.paginate();
    },
    itemsPerPage() {
      this.paginate();
    },
    selectedSearchColumn() {
      this.fetchTopservInvoices();
    },
    $route: function (){
      console.log("route change");
      this.fetchTopservInvoices();
    }
  },
};
</script>

<style lang="css" scoped>
* {
  --warning-color: rgb(255, 178, 76);
  --warning-bg-color: rgb(255, 178, 77, 0.2);
  --error-color: rgb(173, 15, 1);
  --error-bg-color: rgb(173, 15, 1, 0.2);
  --pending-color: rgb(97, 163, 255);
  --pending-bg-color: rgba(97, 163, 255, 0.2);
  --posting-color: rgb(159, 152, 255);
  --posting-bg-color: rgba(159, 152, 255, 0.2);
  --fetching-color: #777a82;
  --fetching-bg-color: rgba(119, 122, 130, 0.2);
  --new-color: #4794eb;
  --new-bg-color: rgba(71, 148, 235, 0.2);
  --text-color: #ffffff;
  --success-color: #0fb45f;
  --success-bg-color: rgba(15, 180, 95, 0.2);
}

.custom-button {
  cursor: pointer;
  /* border: 2px solid red; */
  padding: 0.5rem 1rem;
}

.custom-button:active {
  opacity: 50%;
}

.error-color {
  color: var(--error-color);
  background-color: var(--error-bg-color);
  display: inline-block;
}

.success-color {
  color: var(--success-color);
  background-color: var(--success-bg-color);
  display: inline-block;
}

.warning-color {
  color: var(--warning-color);
  background-color: var(--warning-bg-color);
  display: inline-block;
}

.fetching-color {
  color: var(--fetching-color);
  background-color: var(--fetching-bg-color);
  display: inline-block;
}

.pending-color {
  color: var(--pending-color);
  background-color: var(--pending-bg-color);
  display: inline-block;
}

.new-color {
  color: var(--new-color);
  background-color: var(--new-bg-color);
  display: inline-block;
}

.posting-color {
  color: var(--posting-color);
  background-color: var(--posting-bg-color);
  display: inline-block;
}

.status-card {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  max-width: 200px;
}

.status-card-dialogue {
  border-radius: 1rem;
  padding: 0.4rem 1rem;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
}

/* Additional styling for the table */
.table-container {
  width: 100%; /* Adjust the width as needed */
  overflow-x: auto;

  td,
  th {
    white-space: nowrap;
  }
}

.table-container-detail {
  width: 100%; /* Adjust the width as needed */

  td,
  th {
    white-space: wrap;
  }
}

.customer-table-detail {
  width: calc(100% - 2.7rem);
  margin-bottom: 2.5rem;
}

/* Styling for table headers */
.customer-table-detail th {
  padding: 10px;
  text-align: left;
}

/* Styling for table cells */
.customer-table-detail td {
  padding: 10px;
  height: 40px;
  border: 1px solid rgba(182, 182, 182, 0.528);
}

/* Styling for table rows */
.customer-table-detail tbody tr {
  padding: 10px; /* Add padding to each row */
}

.customer-table-detail tr:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}

.customer-table-detail tr:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

/* ---------------------- */

.table-toolbar {
  padding: 1rem;
}

.custom-table {
  border-collapse: collapse;
  width: 100%; /* Make table width 100% of container */
  overflow: hidden;
}

/* Styling for table headers */
.custom-table th {
  background-color: #f9f9f9;
  padding: 10px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
  height: 60px;
  border-bottom: 1px solid rgb(182, 182, 182);
}

/* Styling for table cells */
.custom-table td {
  padding: 10px;
  text-align: left;
  white-space: nowrap; /* Prevents text wrapping */
}

/* Styling for table rows */
.custom-table tbody tr {
  border-bottom: 1px solid #e6e6e6;
  padding: 10px; /* Add padding to each row */
  height: 60px; /* Add height to each row */
}

.custom-table tbody tr:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}

.custom-table tbody tr:active {
  background-color: #cac8c87b;
  cursor: pointer;
}

.custom-dialogue {
  position: fixed;
  z-index: 99;
  padding: 1.5rem;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  transition: all 0.3s;
}

.custom-dialogue-content-wrapper {
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 1rem;
  height: 100%;
  width: 100%;
  /* border: 5px solid green; */
}

.dialog-header-wrapper {
  /* border: 2px solid green; */
  height: 2.7rem;
}

/* Default styles for .dialog-content-wrapper */
.dialog-content-wrapper {
  /* border: 2px solid red; */
  display: flex;
  padding: 8px 0px;
  height: calc(100% - 2.7rem * 2);
  width: 100%;
}

.dialog-content {
  /* border: 2px solid green; */
  flex: 1;
}

@media (max-width: 947px) {
  .dialog-content-wrapper {
    flex-direction: column;
  }

  .dialog-content-left {
    width: 100%;
    height: 40%;
  }

  .dialog-content-right {
    /* border: 2px solid green; */
    height: calc(60% - 2.7rem);
  }
}

.dialog-footer-wrapper {
  /* border: 2px solid blue; */
  height: 2.7rem;
}

.items-per-page-selector {
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid #ccc;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  background-color: #FFFFFF;
  text-align: center;
}
.total-item {
  width: 100%;
  height: 100%;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  text-align: right;
}
</style>
